/**
 * CommonJS interop shim: `html2canvas` -> `html2canvas-pro`.
 *
 * html2canvas 1.4.1 cannot parse the `oklch()` / `oklab()` colours Tailwind v4
 * computes for every element, so it throws and every html2pdf export fails.
 * html2canvas-pro is the maintained drop-in fork that supports them, but its
 * CJS build is a rollup UMD with *named* exports (`exports.default = fn`),
 * whereas html2canvas 1.4.1 exported the function itself (`module.exports = fn`).
 * html2pdf.js calls the required module directly, so pointing it straight at the
 * fork fails with "html2canvas__WEBPACK_IMPORTED_MODULE_9__ is not a function".
 *
 * Re-exporting the default as the module export restores the shape html2pdf
 * expects. `vite.config.ts` aliases the `html2canvas` specifier here.
 */
const html2canvasPro = require('html2canvas-pro');

module.exports = html2canvasPro.default ?? html2canvasPro;
